<section class="routing-test">
  <puro-typography variant="h4">{{ 'routingTest.title' | translate }}</puro-typography>

  <puro-typography variant="body2">{{ 'routingTest.description' | translate }}</puro-typography>

  <section class="routing-test__panel" aria-labelledby="routing-test-url-state">
    <puro-typography id="routing-test-url-state" variant="h6">
      {{ 'routingTest.urlState' | translate }}
    </puro-typography>

    <dl class="routing-test__state">
      <dt>{{ 'routingTest.browserHref' | translate }}</dt>
      <dd>{{ browserUrl().href || '—' }}</dd>

      <dt>{{ 'routingTest.browserPathname' | translate }}</dt>
      <dd>{{ browserUrl().pathname || '—' }}</dd>

      <dt>{{ 'routingTest.browserSearch' | translate }}</dt>
      <dd>{{ browserUrl().search || '—' }}</dd>

      <dt>{{ 'routingTest.browserHash' | translate }}</dt>
      <dd>{{ browserUrl().hash || '—' }}</dd>

      <dt>{{ 'routingTest.routerUrl' | translate }}</dt>
      <dd>{{ routerUrl() }}</dd>

      <dt>{{ 'routingTest.queryParams' | translate }}</dt>
      <dd>
        @if (queryParams().keys.length === 0) {
          {{ 'routingTest.noQueryParams' | translate }}
        } @else {
          @for (entry of queryParams().keys; track entry) {
            <span class="routing-test__chip">{{ entry }}={{ queryParams().get(entry) }}</span>
          }
        }
      </dd>

      <dt>{{ 'routingTest.routeParams' | translate }}</dt>
      <dd>
        @if (routeParams().keys.length === 0) {
          {{ 'routingTest.noRouteParams' | translate }}
        } @else {
          @for (entry of routeParams().keys; track entry) {
            <span class="routing-test__chip">{{ entry }}={{ routeParams().get(entry) }}</span>
          }
        }
      </dd>

      <dt>{{ 'routingTest.fragment' | translate }}</dt>
      <dd>{{ fragment() ?? ('routingTest.noFragment' | translate) }}</dd>
    </dl>
  </section>

  <section class="routing-test__panel" aria-labelledby="routing-test-links">
    <puro-typography id="routing-test-links" variant="h6">
      {{ 'routingTest.links' | translate }}
    </puro-typography>

    <div class="routing-test__links">
      <button type="button" (click)="navigateWithQueryAndFragment()">
        {{ 'routingTest.navigateWithQueryAndFragment' | translate }}
      </button>

      <a routerLink="/routing-test/legacy">{{ 'routingTest.legacyRedirect' | translate }}</a>

      <a
        routerLink="/routing-test/detail/ITEM-42"
        [queryParams]="{ mode: 'detail' }"
        fragment="section-alpha"
      >
        {{ 'routingTest.detailRoute' | translate }}
      </a>

      <a
        routerLink="/routing-test"
        [queryParams]="{ ref: 'router', tab: 'beta' }"
        fragment="section-beta"
      >
        {{ 'routingTest.routerLinkQueryFragment' | translate }}
      </a>

      <a href="#section-beta">{{ 'routingTest.nativeAnchorLink' | translate }}</a>
    </div>
  </section>

  <section class="routing-test__panel" aria-labelledby="routing-test-anchors">
    <puro-typography id="routing-test-anchors" variant="h6">
      {{ 'routingTest.anchorSections' | translate }}
    </puro-typography>

    <article id="section-alpha" class="routing-test__anchor-target" tabindex="-1">
      <puro-typography variant="h6">{{ 'routingTest.sectionAlpha' | translate }}</puro-typography>

      <puro-typography variant="body2">{{
        'routingTest.sectionAlphaHint' | translate
      }}</puro-typography>
    </article>

    <article id="section-beta" class="routing-test__anchor-target" tabindex="-1">
      <puro-typography variant="h6">{{ 'routingTest.sectionBeta' | translate }}</puro-typography>

      <puro-typography variant="body2">{{
        'routingTest.sectionBetaHint' | translate
      }}</puro-typography>
    </article>

    <article id="redirect-target" class="routing-test__anchor-target" tabindex="-1">
      <puro-typography variant="h6">{{ 'routingTest.redirectTarget' | translate }}</puro-typography>

      <puro-typography variant="body2">{{
        'routingTest.redirectTargetHint' | translate
      }}</puro-typography>
    </article>
  </section>
</section>
